import React, { useEffect, useState, useRef } from "react";
import swal from "sweetalert";
import {
  Col,
  Card,
  Table,
  Dropdown,
  Modal,
  Button,
  Alert,
  Spinner,
  Badge,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Switch from "react-switch";
import { Multiselect } from "multiselect-react-dropdown";
function Packages() {
  var history = useHistory();
  const data = document.querySelectorAll("#job_data tbody tr");
  const sort = 20;
  const activePag = useRef(0);
  const [allPackage, setAllPackages] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [packageName, setPackageName] = useState("");
  const [packageDesc, setPackageDesc] = useState("");
  const [testDesc, setTestDesc] = useState("");
  const [packagePrice, setPackagePrice] = useState("");
  const [testName, setTestName] = useState("");
  const [packages, setPackages] = useState([]);
  const [allTests, setAllTests] = useState([]);
  const handleClose = () => setShow(false);
  const [show, setShow] = useState(false);
  const [popular, setPopular] = useState(false);
  const [featured, setFeatured] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const [delStatus, setDelStatus] = useState(false);
  const [spinner, setSpinner] = useState(true);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [imageData, setImageData] = useState(null);
  const [image, setImage] = useState(null);
  const [packageID, setPackageId] = useState("");
  const [imageKey, setImageKey] = useState("");
  const [allTest, setAllTest] = useState([]);
  const [testID, setTestId] = useState([]);
  const [show1, setShow1] = useState(false);
  const [offerPrice, setOfferPrice] = useState("");
  const [reportDesc, setReportDesc] = useState("");
  function getData() {
    axios
      .get(Baseurl.baseurl + "/health/get-all-health-package-info")
      .then((res) => {
        console.log("dncndncndndndndnd", res.data);
        setSpinner(false);
        setAllPackages(res.data.data);
        setSearchData(res.data.data);
      });
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };

  useEffect(() => {
    getData();
  }, []);

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  function searchRider(value) {
    let filteredData = [];
    searchData.map((val) => {
      let price = val.Price.toString();
      if (val.Name.toLowerCase().includes(value) || price.includes(value)) {
        filteredData.push(val);
      }
    });
    setAllPackages(filteredData);
  }
  const Add = () => {
    const test = {
      testname: testName,
      testdesc: testDesc,
    };
    setPackages(
      (oldArray) => oldArray.concat(test),
      () => {}
    );
    setTestName("");
    setTestDesc("");
    setPopular(false);
    setFeatured(false);
    setIsNew(false);
    swal("Added", "Added successfully", "success", {
      showCancelButton: true,
      timer: 1000,
    });
  };
  function removeItem(i) {
    packages.splice(i, 1);
  }
  const onChangePicture = (e) => {
    if (e.target.files[0].size / 1048576 < 3) {
      setImage(e.target.files[0]);
      if (e.target.files[0]) {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          setImageData(reader.result);
        });
        reader.readAsDataURL(e.target.files[0]);
      }
    } else {
      swal("Oops", "image size should be less than 3MB", "error", {
        button: "Done",
        timer: 2000,
      });
      setImageData(null);
    }
  };
  function addPackages() {
    const data = new FormData();
    let testJson = {
      Name: packageName,
      Description: packageDesc,
      Price: packagePrice,
      Tests: testID,
      Popular: popular,
      Featured: featured,
      IsNew: isNew,
      OfferPrice: offerPrice,
      Report:reportDesc
    };
    data.append("data", JSON.stringify(testJson));
    data.append("image", image);
    var config = {
      method: "post",
      url: `${Baseurl.baseurl}/health/create-health-package`,
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.status) {
          getData();
          setPackageName("");
          setTestId([])
          setImage(null);
          setImageData(null);
          setPackageDesc("");
          setPackagePrice("");
          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });

    handleClose();
  }
  function addFields(val) {
    let testFields = [];
    if (val === "popular") {
      testFields = {
        popular: !popular,
      };
    }
    if (val === "featured") {
      testFields = {
        featured: !featured,
      };
    }
    if (val === "isnew") {
      testFields = {
        new: !isNew,
      };
    }
    axios
      .put(
        Baseurl.baseurl +
          `/health/update-health-package-${val}/${packageID}`,
        testFields
      )
      .then((response) => {
        getData();
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function getAllTests(value) {
    axios
      .get(Baseurl.baseurl + "/health/get-all-health-test")
      .then((res) => {
        if (value) {
          let filterArray = res.data.data;
          filterArray = filterArray.filter(function (obj) {
            return !this.has(obj._id);
          }, new Set(value.map((obj) => obj._id)));
          setAllTest(filterArray);
        } else {
          setAllTest(res.data.data);
        }
      });
  }
  const selection1 = (selectedValues) => {
    console.log("selected", selectedValues);
    let id = [];
    selectedValues.map((val) => {
      id.push(val._id);
    });
    setTestId(id);
  };
  function addTestToPackage() {
    let testArray = {
      testID: testID,
    };
    axios
      .put(
        Baseurl.baseurl +
          `/health/add-test-to-health-package/${packageID}`,
        testArray
      )
      .then((response) => {
        if (response.data.status) {
          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          getData();
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        handleClose();
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function updatePackages() {
    let testFields = {
      name: packageName,
      desc: packageDesc,
      price: packagePrice,
      oPrice: offerPrice,
      report: reportDesc,
    };
    axios
      .put(
        Baseurl.baseurl +
          `/health/update-health-package-info/${packageID}`,
        testFields
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    handleClose();
  }
  function deletePackage() {
    axios
      .delete(
        Baseurl.baseurl +
          `/health/delete-health-package-info-by-id/${packageID}`
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    setShow1(false);
  }
  function removeTests(val, test) {
    let testFields = {
      testID: val,
    };
    axios
      .put(
        Baseurl.baseurl +
          `/health/remove-test-to-health-package/${test}`,
        testFields
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          setShow1(false)
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function updatePackageImage() {
    const data = new FormData();
    data.append("image", image);
    data.append("packageImageKey", imageKey);

    var config = {
      method: "put",
      url: `${Baseurl.baseurl}/health/update-health-package-image/${packageID}`,
      data: data,
    };
    axios(config)
      .then(function (response) {
        if (response.data.status) {
          getData();

          swal("Updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });

    handleClose();
  }
  function updateFunction(val) {
    setShow(true);
    setPackageId(val._id);
    setUpdateStatus(true);
    setPackageName(val.Name);
    setPackageDesc(val.Description);
    setPackagePrice(val.Price);
    setImageData(val.Image);
    setImageKey(val.ImageKey);
    getAllTests(val.Tests);
    setPopular(val.Popular);
    setFeatured(val.Featured);
    setIsNew(val.IsNew);
    setOfferPrice(val.OfferPrice);
    setReportDesc(val.Report);
  }
  function JSONToCSV(data) {
    const keys = Object.keys(data[0]);
    const csvData = [keys.join(",")];
  
    for (let item of data) {
      const values = keys.map((key) => {
        const value = item[key];
        return value !== undefined ? `"${String(value).replace(/"/g, '""')}"` : "";
      });
      csvData.push(values.join(","));
    }
  
    return csvData.join("\n");
  }
  function downloadBulk(exportJson) {
    console.log("donwload data", exportJson);
    const csvContent = "data:text/csv;charset=utf-8," + JSONToCSV(exportJson);
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `packages.csv`);
    link.click();
  }
  return (
    <Col lg={12}>
      <Modal
        show={show1}
        onHide={() => {
          setShow1(false);
        }}
      >
        {delStatus && (
          <Modal.Header closeButton>
            <Modal.Title>Delete Package</Modal.Title>
          </Modal.Header>
        )}
        <Modal.Body>
          {delStatus ? (
            <h4>Are You Sure You Want to Delete This Package ?</h4>
          ) : (
            <div>
              {allTests.length===0&&(
              <h4 className="text-center">No Packages Added</h4>
            )}
              {allTests&&allTests.map((test) => {
               
                return (
                  <div className="row">
                    <div className="col-sm-8 mt-3">
                      <strong>{test.Name}</strong>
                    </div>
                    <div className="col-sm-2 mt-3">
                      <Link
                        onClick={() => {
                          removeTests(test._id, packageID);
                        }}
                        href="#"
                        className="btn btn-danger shadow btn-xs sharp"
                      >
                        <i className="fa fa-trash"></i>
                      </Link>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </Modal.Body>
        {delStatus && (
          <Modal.Footer>
            <button
              onClick={() => {
                deletePackage();
              }}
              className="btn btn-primary"
            >
              Delete
            </button>
          </Modal.Footer>
        )}
      </Modal>
      <Modal size={"lg"} show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{updateStatus?`Update Package (${packageID})`:"Add Package"} </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="row">
             
              <div className="col-sm-6">
              <label>
                  Package Name<span className="text-danger">*</span>
                </label>
                <input
                  value={packageName}
                  type="text"
                  className="form-control"
                  placeholder="enter package Name"
                  onChange={(e) => setPackageName(e.target.value)}
                  required
                />
              </div>

             
              <div className="col-sm-6">
              <label>
                  Package Description<span className="text-danger">*</span>
                </label>
                <textarea
                  value={packageDesc}
                  type="text"
                  className="form-control"
                  placeholder="enter Description"
                  onChange={(e) => setPackageDesc(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="row mt-3">
            
              <div className="col-sm-6 ">
              <label>
                  Package Price (₹)<span className="text-danger">*</span>
                </label>
                <input
                  required
                  type="number"
                  className="form-control"
                  id="val-username"
                  name="val-username"
                  value={packagePrice}
                  onChange={(e) => setPackagePrice(e.target.value)}
                  placeholder="Enter price"
                />
              </div>
             
              <div className="col-sm-6">
              <label>
                  Offer Price (₹) <span className="text-danger">*</span>
                </label>
                <input
                  value={offerPrice}
                  type="number"
                  className="form-control"
                  placeholder="enter offer Price"
                  onChange={(e) => setOfferPrice(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="row mt-3">
              <div className={`col-sm-${updateStatus?"5":"6"} mb-3`} id="multiselect">
                <label>Tests</label>
                <Multiselect
                  options={allTest}
                  displayValue="Name"
                  onSelect={selection1}
                />
              </div>
              {updateStatus && (
                <div className="col-sm-1 mt-4 p-0">
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      addTestToPackage();
                    }}
                  >
                    Add
                  </button>
                </div>
              )}
               <div className="col-sm-2">
              <label>Popular</label>
                <Switch
                  onChange={() => {
                    setPopular(!popular);
                    if (updateStatus) {
                      addFields("popular");
                    }
                  }}
                  checked={popular}
                />
              </div>
            
              <div className="col-sm-2">
              <label>Featured</label>
                <Switch
                  onChange={() => {
                    setFeatured(!featured);
                    if (updateStatus) {
                      addFields("featured");
                    }
                  }}
                  checked={featured}
                />
              </div>
              
              
              <div className="col-sm-2">
              <label>New Package</label>
                <Switch
                  onChange={() => {
                    setIsNew(!isNew);
                    if (updateStatus) {
                      addFields("isnew");
                    }
                  }}
                  checked={isNew}
                />
              </div>
            </div>
            <div className="row mt-3">
             
              <div classname="col-sm-5">
                <div>
                <label >
                  Image
                  <span className="text-danger">*</span>
                </label>
                </div>
                <input
                  id="profilePic"
                  type="file"
                  onChange={(e) => {
                    onChangePicture(e);
                  }}
                />
                {imageData && (
                  <div
                    style={{
                      marginTop: "5px",
                      width: 180,
                      height: 100,
                      aspectRatio: 1 * 1.4,
                    }}
                    className="previewProfilePic"
                  >
                    <img
                      alt=""
                      className="playerProfilePic_home_tile"
                      style={{
                        resizeMode: "cover",
                        width: "100%",
                        height: "100%",
                      }}
                      src={imageData}
                    />
                  </div>
                )}
              
              </div>
              
                  <div className="col-sm-2 text-center mt-5">
                  {updateStatus && (
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        updatePackageImage();
                      }}
                    >
                      Change
                    </button>
                     )}
                  </div>
               
                 <div className="col-sm-5">
              <label>
                  Report Description<span className="text-danger">*</span>
                </label>
                <textarea
                  value={reportDesc}
                  type="text"
                  className="form-control"
                  placeholder="enter Description"
                  onChange={(e) => setReportDesc(e.target.value)}
                  required
                />
              </div>
            </div>
         
          </div>
        </Modal.Body>
        <Modal.Footer>
          {updateStatus ? (
            <button
              onClick={() => {
                updatePackages();
              }}
              className="btn btn-primary"
            >
              Update
            </button>
          ) : (
            <button
              onClick={() => {
                addPackages();
              }}
              className="btn btn-primary"
            >
              Submit
            </button>
          )}
        </Modal.Footer>
      </Modal>

      <Card
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <Card.Header>
        <div
            style={{ marginTop: 0 }}
            className="btn btn-secondary"
            onClick={() => {
              let downloadData = [];
              allPackage.map((val) => {
                downloadData.push({
                  PackageName: val.Name || "",
                  PackageDescription: val.Description || "",
                  Price: val.Price || "",
                  OfferPrice: val.OfferPrice || "",
                  Report: val.Report || "",
                  Featured: val.Featured ? "Yes" : "No",
                  New: val.IsNew ? "Yes" : "No",
                  Popular: val.Popular ? "Yes" : "No",
                  Test: Array.isArray(val.Tests) ? val.Tests.map((item) => item.Name).join(", ") : "",
                });
              });
              downloadBulk(downloadData);
            }}
          >
            Download
          </div>
          <div>
            <input
              type="text"
              className="form-control"
              placeholder="Search here..."
              onChange={(e) => {
                searchRider(e.target.value);
              }}
            />
          </div>
          <button
            onClick={() => {
              setShow(true);
              setUpdateStatus(false);
              setPackageName("");
              setPackageDesc("");
              setPackagePrice("");
              setImageData(null);
              getAllTests();
              setOfferPrice("");
              setPopular(false);
              setFeatured(false);
              setIsNew(false);
              setReportDesc("")
            }}
            className="btn btn-primary"
          >
            Add Package
          </button>
        </Card.Header>
        <Card.Body>
          <div id="job_data" className="dataTables_wrapper ">
            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Table className="text-white" responsive>
                <thead>
                  <tr>
                    <th>
                      <strong>Image</strong>
                    </th>
                    {/* <th>
                      <strong>Id</strong>
                    </th> */}
                    <th>
                      <strong>Name</strong>
                    </th>
                    <th>
                      <strong>Description</strong>
                    </th>
                    <th>
                      <strong>Price</strong>
                    </th>
                    <th>
                      <strong>offer price</strong>
                    </th>
                    {/* <th>
                      <strong className="col-sm-6">Tests</strong>
                    </th> */}

                    {/* <th>
                      <strong>Featured</strong>
                    </th>
                    <th>
                      <strong>New</strong>
                    </th> */}
                    <th>
                      <strong>Report</strong>
                    </th>
                    <th>
                      <strong>Actions</strong>
                    </th>
                  </tr>
                </thead>
                <tbody style={{fontSize:"13px"}}>
                  {allPackage &&
                    allPackage.map((val, key) => (
                      <tr key={val._id}>
                        <td>
                          <div >
                            <img
                              src={val.Image}
                              height={50}
                              width={50}
                              alt="profile"
                            />
                          </div>
                        </td>
                        {/* <td>{val._id}</td> */}
                        <td>{val.Name}</td>
                        <td>{val.Description}</td>
                        <td>₹{val.Price}</td>
                        <td>₹{val.OfferPrice}</td>
                        {/* <td className="col-sm-8">
                          {val.Tests.map((test) => {
                            return (
                              <div className="row">
                                <div className="col-sm-8 mt-3">
                                  <strong>{test.Name}</strong>
                                </div>
                                <div className="col-sm-2 mt-3">
                                  <Link
                                    onClick={() => {
                                      removeTests(test._id, val._id);
                                    }}
                                    href="#"
                                    className="btn btn-danger shadow btn-xs sharp"
                                  >
                                    <i className="fa fa-trash"></i>
                                  </Link>
                                </div>
                              </div>
                            );
                          })}
                        </td> */}
                        {/* <td>{val.Featured.toString()}</td>
                        <td>{val.IsNew.toString()}</td> */}
                        <td>{val.Report}</td>
                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="warning"
                              className="light sharp i-false"
                            >
                              {svg1}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => {
                                  updateFunction(val);
                                }}
                              >
                                Update
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                  setPackageId(val._id);
                                  setShow1(true);
                                  setDelStatus(false);
                                  setAllTests(val.Tests);
                                }}
                              >
                                View Tests
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                  setPackageId(val._id);
                                  setShow1(true);
                                  setDelStatus(true);
                                }}
                              >
                                Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}

            {!allPackage && (
              <Alert
                variant="success"
                className="alert-dismissible fade show text-center"
              >
                Zero allPackage
              </Alert>
            )}
            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
              <div className="dataTables_info text-white">
                Showing {activePag.current * sort + 1} to{" "}
                {data.length > (activePag.current + 1) * sort
                  ? (activePag.current + 1) * sort
                  : data.length}{" "}
                of {data.length} entries
              </div>
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="example5_paginate"
              >
                <Link
                  className="paginate_button previous disabled"
                  onClick={() =>
                    activePag.current > 0 && onClick(activePag.current - 1)
                  }
                >
                  Previous
                </Link>
                <span>
                  {paggination.map((number, i) => (
                    <Link
                      key={i}
                      className={`paginate_button  ${
                        activePag.current === i ? "current" : ""
                      } `}
                      onClick={() => onClick(i)}
                    >
                      {number}
                    </Link>
                  ))}
                </span>
                <Link
                  className="paginate_button next"
                  onClick={() => {
                    activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1);
                  }}
                >
                  Next
                </Link>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default Packages;
